export const UPDATES = {
  ROOT: '/updates',
};
